export * from './mobile-format-strategy';
export * from './mobile-length-strategy';
export * from './mobile-strategy';
